import { jsx as c } from "react/jsx-runtime";
import { useCallback as k } from "react";
import { MenuItem as t } from "../Menu/index.es.js";
import { Text as u } from "@chakra-ui/react";
const p = ({
  option: r,
  isSelected: m = !1,
  size: o = "md",
  variant: b = "ghost",
  onSelectOption: i,
  ...d
}) => {
  const f = k(({ onChange: a, value: l, ...s }) => {
    i == null || i({ onChange: a, value: l, ...s }), a == null || a(l);
  }, []);
  return /* @__PURE__ */ c(
    t,
    {
      onClick: () => f(r),
      icon: r.icon,
      backgroundColor: m ? "primary.50" : "white",
      "track-id": r.trackId,
      ...d,
      children: /* @__PURE__ */ c(
        u,
        {
          color: m ? "primary.700" : "primary.500",
          fontWeight: m ? "medium" : "normal",
          fontSize: m ? "lg" : "md",
          as: "span",
          children: r.label
        }
      )
    },
    r.value
  );
};
export {
  p as SelectDropdownMenuItem
};
//# sourceMappingURL=SelectDropdownMenuItem.es.js.map
